export const surveyModel = 'survey';
export const pageModel = 'page';
export const questionModel = 'question';
export const answerModel = 'answer';
export const submissionModel = 'submission';
export const responseModel = 'response';

export const SubmissionStatus = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted'
}
